import { type WidgetSetting } from "@repo/api";

import { getCoworkerSettingsValue } from "../../customize/settings/CoworkerSettingsControl";

export const getWidgetSettings = (settings?: WidgetSetting) => {
  const { email, teamId, assignedToTeam } = getCoworkerSettingsValue(
    settings?.["COWORKER"]?.toString() ?? ""
  );

  const unitIds = settings?.STORE
    ? Array.isArray(settings.STORE)
      ? settings.STORE
      : [settings.STORE]
    : undefined;

  const resolvedEmail = email?.length > 0 ? email : undefined;

  return {
    unitId: unitIds,
    email: resolvedEmail,
    teamId,
    assignedToTeam,
    status: settings?.status ?? [],
    installQuoteValueFilter: settings?.quotationValue ?? [],
    docusignDateSentFilter: settings?.docusignDateSentFilter,
    installationFromDateFilter: settings?.installationFromDateFilter,

    depositPaid: settings?.depositPaid ?? undefined,
  };
};

export const mapInstallationQuotationData = <T>(
  existingArray: T[],
  newArray: T[]
): T[] => {
  const uniqueItems = new Set([
    ...existingArray.map((item) => JSON.stringify(item)),
    ...newArray.map((item) => JSON.stringify(item)),
  ]);
  return Array.from(uniqueItems).map((item) => JSON.parse(item));
};
